import autobind from "autobind-decorator";
import React from "react";

import { OrganizationWrapper } from "common/entities/organizationWrapper/OrganizationWrapper";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { CardVariant, CardView } from "common/views/card/Card.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import IconView from "common/views/icon/Icon.view";
import { IQueryOne, QueryOne } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import Organization from "./entities/Organization";
import labelProvider from './OrganizationStats.labels';
import Config from "./OrganizationStatsConfig";

const { Labels } = labelProvider;

@Panel({id: "organization-stats", configClass: Config, pageParams: true})
@QueryOne(Organization, {}, true)
export default class OrganizationStatsPanel extends React.PureComponent<IPanelProps<Config> & IQueryOne<Organization>> {

	@autobind
	public getQueryParams(): object {
		return {guid: this.props.pageParams.guid};
	}

	public render() {
		const { config, entity } = this.props;
		const { showCourseCount, showDiscussionCount, showUserCount, vertical } = config;

		if (!entity) { return null; }
		const ow = new OrganizationWrapper({ organization: entity });

		const containerStyles = vertical ? undefined : {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between"
		};

		return (
			<div style={containerStyles as any}>
				{
					showUserCount && (
						<CardView variant={CardVariant.SURFACE} viewKey="user-count">
							<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-content">
								<IconView icon="user" viewKey="user-count-data">
									<div>
										{ow.getUserCount()}
										<HeadingView variant={HeadingVariant.H4} viewKey="user-count-label">
											<Labels.Members/>
										</HeadingView>
									</div>
								</IconView>
							</BlockView>
						</CardView>
					)
				}
				{
					showDiscussionCount && (
						<CardView variant={CardVariant.SURFACE} viewKey="discussion-count">
							<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-content">
								<IconView icon="comment" viewKey="discussion-count-data">
									{ow.getDisucssionCount()}
									<HeadingView variant={HeadingVariant.H4} viewKey="stat-label">
										<Labels.Discussions/>
									</HeadingView>
								</IconView>
							</BlockView>
						</CardView>
					)
				}
				{
					showCourseCount && (
						<CardView variant={CardVariant.SURFACE} viewKey="course-count">
							<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-content">
								<IconView icon="document" viewKey="course-count-data">
									{ow.getEntryCount()}
									<HeadingView variant={HeadingVariant.H4} viewKey="course-count-label">
										<Labels.Courses/>
									</HeadingView>
								</IconView>
							</BlockView>
						</CardView>
					)
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/stats/OrganizationStats.panel.tsx